/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-exam-and-treatment.reducer';

export const DentalExamAndTreatmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalExamAndTreatmentEntity = useAppSelector(state => state.dentalExamAndTreatment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalExamAndTreatmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.detail.title">DentalExamAndTreatment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.id}</dd>
          <dt>
            <span id="examination">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.examination">Examination</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.examination ? 'true' : 'false'}</dd>
          <dt>
            <span id="treatment">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.treatment">Treatment</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.treatment ? 'true' : 'false'}</dd>
          <dt>
            <span id="groupOnly">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.groupOnly">Group Only</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.groupOnly ? 'true' : 'false'}</dd>
          <dt>
            <span id="groupName">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.groupName">Group Name</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.groupName}</dd>
          <dt>
            <span id="examName">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.examName">Exam Name</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.examName}</dd>
          <dt>
            <span id="treatmentName">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.treatmentName">Treatment Name</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.treatmentName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {dentalExamAndTreatmentEntity.lastUpdated ? (
              <TextFormat value={dentalExamAndTreatmentEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {dentalExamAndTreatmentEntity.microSec ? (
              <TextFormat value={dentalExamAndTreatmentEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {dentalExamAndTreatmentEntity.timestampEntry ? (
              <TextFormat value={dentalExamAndTreatmentEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.hospital">Hospital</Translate>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.hospital ? dentalExamAndTreatmentEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.group">Group</Translate>
          </dt>
          <dd>{dentalExamAndTreatmentEntity.group ? dentalExamAndTreatmentEntity.group.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/dental-exam-and-treatment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-exam-and-treatment/${dentalExamAndTreatmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalExamAndTreatmentDetail;
